import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import WorkerCard from "../../components/workers/WorkerCard";
import apiClientFiles from "../../components/utils/apiClientFiles";
import Toast from "../../components/shared/Toast";
import ModalContainer from "../../containers/shared/ModalContainer";
import moment from "moment";

const UsersHomePage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('nav.workers'));
    const navigate = useNavigate();
    const pageTitle = {title: t('nav.workers')};
    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const [workers, setWorkers] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:''});

    const [showGoldenStarModal, setShowGoldenStarModal] = useState(false);
    const [isGoldieDetailsOpen, setIsGoldieDetailsOpen] = useState(false);

    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    const getWorkers = async () => {

      try {
        const response = await apiClient.get(`/users?types=worker&vendorsId=${user?._id}`);
        if(response?.data) {
          setWorkers(response?.data);
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
            getWorkers();
        }
    },[user])

    const handleClickDownloadWorkersReport = async () => {
      try {
          const response = await apiClientFiles.get(`/report/download/usersData?role=worker&vendorsId=${vendor?._id}`,{
              responseType: 'blob',
            });
          if(response.data) {
              let fileURL = URL.createObjectURL(response.data);
              let fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.download = 'report-workers';
              fileLink.click();
          } else {
            setToast({show:true,type:'error',message:t('requests.errorOccurredRetry')});
          }
        } catch(err) {setToast({show:true,type:'error',message:t('requests.errorOccurredRetry')});}
    }

    const handleClickFanniGoldie = async () => {
      if(vendor?.currentGoldenStarSubscriptionType) {
        setShowGoldenStarModal(true);
      } else {
        navigate(`/${i18n?.language || 'ar'}/workers/goldie`);
      }
    }

    const handleCloseModal = () => {
      setShowGoldenStarModal(false);
    }

    const getExtraTchCount = () => {
      let count;
      if(vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 && vendor?.workersCount > vendor?.activeSubscription?.plan?.features?.TechniciansCount) {
        count = vendor?.workersCount - vendor?.activeSubscription?.plan?.features?.TechniciansCount;
      } else {
        count = 0;
      }
      return count;
    }

    const getOriginalGoldie = () => {
      return vendor?.activeSubscription?.plan?.goldStarFees ? vendor?.activeSubscription?.plan?.goldStarFees[vendor?.currentGoldenStarSubscriptionType] : 0;
    }

    const getExtraGoldie = () => {
      return vendor?.activeSubscription?.plan?.extraGoldStarFees ? getExtraTchCount() * vendor?.activeSubscription?.plan?.extraGoldStarFees[vendor?.currentGoldenStarSubscriptionType] : 0;
    }

    const getTotalGoldie = () => {
      return getOriginalGoldie() + getExtraGoldie();
    }

    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])
    

  return (
    <>
     <div>
      <PageHeader pageTitle={pageTitle} />
      <PageMain>
        <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
        {vendor && <MainContent>
          <div className="border-[1px] border-grey-200 rounded-[16px] px-[15px] lg:px-[20px] py-[20px] lg:py-[30px] my-[25px] bg-white">
            <div className="flex flex-wrap lg:flex-nowrap lg:h-[146px]">
              <div className="w-full lg:w-[calc(100%-341px)] border-b-[1px] lg:border-b-0 lg:border-e-[1px] border-grey-200 pb-[16px] lg:pb-0">
                {vendor?.activeSubscription
                ? <>
                <div className="text-grey-900 text-[18px] lg:text-[24px] font-[600] leading-[28px] lg:leading-[36px]">{t('workers.workersDetails')}</div>
                <div className="flex flex-wrap lg:flex-nowrap mt-[16px] lg:mt-[25px] pt-[16px] lg:pt-[20px] border-t-[1px] border-grey-200 gap-y-[16px]">
                  <div className="w-[50%] lg:min-w-[200px] lg:w-auto pe-[20px] h-auto lg:h-[60px] relative">
                    {vendor?.activeSubscription?.plan?.features?.TechniciansCount === 0
                      ? <strong className="text-[18px] lg:text-[24px] text-grey-900 font-[600] leading-[28px] lg:leading-[36px]">{vendor?.workersCount}/{t('workers.unlimited')}</strong>
                      : <strong className="text-[18px] lg:text-[24px] text-grey-900 font-[600] leading-[28px] lg:leading-[36px]">{vendor?.workersCount ? (vendor?.workersCount > vendor?.activeSubscription?.plan?.features?.TechniciansCount) ? vendor?.activeSubscription?.plan?.features?.TechniciansCount : vendor?.workersCount : 0}/<span dir="ltr">{vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 ? vendor?.activeSubscription?.plan?.features?.TechniciansCount : t('workers.unlimited')}</span> {(parseInt(vendor?.workersCount) - parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount)) > 0 ? <small className="inline-block align-top">{`(+${(parseInt(vendor?.workersCount) - parseInt(vendor?.activeSubscription?.plan?.features?.TechniciansCount))} ${t('workers.outsidePackage')})`}</small> : '' }  </strong>
                    }
                    <p className="text-[13px] lg:text-[14px] text-grey-600 font-[500]">
                      <img src="/assets/images/workers-count-icon.svg" alt="" className="inline-block align-sub me-[3px]" />
                      {t('workers.workersCount')}
                    </p>
                    <span className="absolute hidden lg:block w-[1px] h-[40px] bg-grey-300 end-0 top-[10px]"></span>
                  </div>
                  <div className="w-[50%] lg:w-[260px] h-auto lg:h-[60px] lg:ps-[60px] relative">
                    <strong className="text-[18px] lg:text-[24px] text-grey-900 font-[600] leading-[28px] lg:leading-[36px]">
                      {Array.isArray(vendor?.city) ? vendor?.city?.length : 1}
                    </strong>
                    <p className="text-[13px] lg:text-[14px] text-grey-600 font-[500]">
                      <img src="/assets/images/workers-cities-icon.svg" alt="" className="inline-block align-sub me-[3px]" />
                      {t('workers.citiesCount')}
                    </p>
                    <span className="absolute hidden lg:block w-[1px] h-[40px] bg-grey-300 end-0 top-[10px]"></span>
                  </div>
                  <div className="w-[50%] lg:w-[200px] ltr:lg:w-[300px] h-auto lg:h-[60px] lg:ps-[60px] relative">
                    <strong className="text-[18px] lg:text-[24px] text-grey-900 font-[600] leading-[28px] lg:leading-[36px]">{vendor?.fields?.length || 0}</strong>
                    <p className="text-[13px] lg:text-[14px] text-grey-600 font-[500]">
                      <img src="/assets/images/workers-fields-icon.svg" alt="" className="inline-block align-sub me-[3px]" />
                      {t('workers.specializationsCount')}
                    </p>
                  </div>
                </div>
                </>
                : <div className="text-darkBlue text-[20px] lg:text-[24px] font-[600] leading-[30px] lg:leading-[36px] pt-[20px] lg:pt-[50px]">{t('workers.noActivePackage')}</div> }
              </div>
              <div className="w-full lg:w-[341px] flex flex-wrap justify-start lg:justify-end items-center content-center gap-[12px] mt-[16px] lg:mt-0 lg:translate-y-[-12px]">
                <div className="w-full lg:w-[324px] h-[48px] leading-[48px] bg-orange text-white rounded-[8px] text-center font-[600] text-[16px] lg:text-[18px] cursor-pointer transition-transform hover:scale-105" onClick={()=>handleClickFanniGoldie()}>
                  <img src="/assets/images/workers-star-icon.svg" alt="" className="inline-block me-[5px]" />
                  {t('workers.goldieSubscription')}
                </div>
                <Link to={`/${i18n?.language || 'ar'}/workers/add`} className="w-full lg:w-[324px] h-[48px] leading-[48px] bg-darkBlue text-white rounded-[8px] text-center font-[600] text-[16px] lg:text-[18px] transition-transform hover:scale-105">
                  <img src="/assets/images/workers-add-icon.svg" alt="" className="inline-block me-[5px]" />
                  {t('workers.addNewWorker')}
                </Link>
              </div>
            </div>
          </div>

          {workers && <div className="flex flex-wrap gap-[16px] mt-[24px]">
            {Array.isArray(workers) && workers?.length > 0 ? workers?.map((worker,index)=>{
              return <WorkerCard key={`worker-${index}`} worker={worker} />
            })
          : <div className="pt-[80px] text-center mx-auto">
              <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/main-user-icon.svg')"}}></div>
              <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">{t('workers.noWorkersAdded')}</div>
              <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-[#212E35] text-[18px] font-[600]" to={`/${i18n?.language || 'ar'}/workers/add`}>{t('workers.addNewWorkerBtn')}</Link>
            </div>}
          </div>}
          
          <br />
          <br />
        </MainContent>}
      </PageMain>
    </div>

    { showGoldenStarModal && <ModalContainer maxWidth={i18n?.language === 'ar' ? '775px' : '900px'} heading={t('workers.goldieSubscription')} handleCloseModal={handleCloseModal}>
      <div className="bg-grey-50 border-[1px] border-grey-200 rounded-[16px] p-[20px] my-[24px]">
          <div className="lg:h-[36px] leading-[36px] flex flex-nowrap mb-[24px]">
            <div className="w-[50%] font-[500] text-[14px] text-grey-600">
              <img src="/assets/images/settings-cal.svg" alt="" className="inline-block align-middle me-[4px]" />
              {t('workers.subscriptionRenewalDate')}
              <span className="inline-block align-middle ms-[8px] text-darkBlue font-[600] text-[24px]">{vendor?.featuredSubscriptionValidTo && moment(vendor?.featuredSubscriptionValidTo).format('DD/MM/YYYY')}</span>
            </div>
            <div className="w-[50%] text-end">
              <span className="font-[600] text-[14px] text-danger underline cursor-pointer cairo-font">{t('workers.cancelSubscription')}</span>
            </div>
          </div>
          <div className="py-[24px] border-t-[1px] lg:h-[108px] border-grey-200 flex flex-wrap lg:flex-nowrap">
            <div className="w-[50%] lg:w-[33.333%] max-w-[211px] relative text-start">
              <div className="inline-block text-start">
                <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                  {getExtraTchCount() > 0 ?  vendor?.activeSubscription?.plan?.features?.TechniciansCount : vendor?.workersCount }/<span dir="ltr">{vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 ? vendor?.activeSubscription?.plan?.features?.TechniciansCount : t('workers.unlimited')}</span>
                </div>
                <p className="text-[14px] ltr:text-[12px] text-grey-600 font-[500] mt-[4px]">
                  <img src="/assets/images/workers-count-icon.svg" alt="" className="inline-block align-sub me-[3px]" />
                  {t('workers.workersInsidePackage')}
                </p>
              </div>
              <span className="block absolute bg-grey-300 w-[1px] h-[40px] top-[10px] end-0"></span>
            </div>
            <div className="w-[50%] lg:w-[33.333%] lg:min-w-[272px] relative text-center">
              <div className="inline-block text-start">
                <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                  {getExtraTchCount()}
                </div>
                <p className="text-[14px] ltr:text-[12px] text-grey-600 font-[500] mt-[4px]">
                  <img src="/assets/images/workers-count-icon.svg" alt="" className="inline-block align-sub me-[3px]" />
                  {t('workers.workersOutsidePackage')}
                </p>
              </div>
              <span className="absolute bg-grey-300 w-[1px] h-[40px] top-[10px] end-0 hidden lg:block"></span>
            </div>
            <div className="w-[50%] lg:w-[33.333%] lg:max-w-[200px] relative lg:text-end pt-[15px] lg:pt-0">
              <div className="inline-block text-start">
                <div className="leading-[36px] font-[600] text-[24px] text-darkBlue">
                  {vendor?.activeGoldenStarSubscriptions[0]?.totalCost}
                  <img src="/assets/images/green-sar.svg" alt="" className="inline-block align-baseline ms-[4px]" />
                </div>
                <p className="text-[14px] ltr:text-[12px] text-grey-600 font-[500] mt-[4px]">
                  <img src="/assets/images/settings-price.svg" alt="" className="inline-block align-sub me-[3px]" />
                  {t('workers.monthlySubscriptionAmount')}
                </p>
              </div>
            </div>
          </div>
          {getExtraTchCount() > 0 && <><div className="border-t-[1px] border-grey-300 pt-[24px] flex flex-nowrap">
            <div className="w-[75%] text-start">
              <p className="text-[14px] text-grey-600 font-[500] leading-[21px]">
                <img src="/assets/images/settings-price.svg" alt="" className="inline-block align-sub me-[4px]" />
                {t('workers.subscriptionDetails')} {vendor?.currentGoldenStarSubscriptionType === 'WEEKLY' ? t('workers.weeklySubscription') : t('workers.monthlySubscription')}
              </p>
            </div>
            <div className="w-[50%] text-end">
              {isGoldieDetailsOpen 
              ? <img src="/assets/images/minus-square.svg" alt="" className="inline-block align-baseline cursor-pointer" onClick={()=>setIsGoldieDetailsOpen(false)} />
              : <img src="/assets/images/add-square.svg" alt="" className="inline-block align-baseline cursor-pointer" onClick={()=>setIsGoldieDetailsOpen(true)} />}
            </div>
          </div>
          {isGoldieDetailsOpen && <div className="">
            <div className="pt-[12px] leading-[21px] flex flex-nowrap">
              <div className="w-[75%] text-start font-[500] text-[14px] text-grey-600">{t('workers.workersInsidePackageSubscription')} {`(${vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 ? vendor?.activeSubscription?.plan?.features?.TechniciansCount : t('workers.unlimited')})`}</div>
              <div className="w-[25%] text-end font-[500] text-[14px] text-grey-900">{getOriginalGoldie()} <img src="/assets/images/pack-sar.svg" alt="" className="w-[11px] inline-block align-baseline ms-[4px]" /></div>
            </div>
            <div className="pt-[12px] leading-[21px] flex flex-nowrap">
              <div className="w-[75%] text-start font-[500] text-[14px] text-grey-600">{t('workers.workersOutsidePackageSubscription')} {`(${getExtraTchCount()})`}</div>
              <div className="w-[25%] text-end font-[500] text-[14px] text-grey-900">{getExtraGoldie()} <img src="/assets/images/pack-sar.svg" alt="" className="w-[11px] inline-block align-baseline ms-[4px]" /></div>
            </div>
          </div>}</>}
      </div>
      <div className="w-full text-end">
        <div className="w-full max-w-[103px] inline-block text-center cursor-pointer select-none text-white bg-darkBlue rounded-[8px] h-[48px] leading-[48px] font-[600] text-[18px]" onClick={handleCloseModal}>{t('workers.close')}</div>
      </div>
    </ModalContainer> }


    <Toast toast={toast} setToast={setToast} />
    {!vendor && <Loading showLoading={true} />}
    </>
  );
};

export default UsersHomePage;
